// extracted by mini-css-extract-plugin
export var alignCenter = "_8r-d";
export var bannerShown = "_8r-6";
export var buttonContent = "_8r-0";
export var cardList = "_8r-1";
export var centerContent = "_8r-2";
export var chevron = "_8r-3";
export var closePanelButton = "_8r-k";
export var conversationContextContainer = "_8r-l";
export var conversationDetailContainer = "_8r-4";
export var detailWrapper = "_8r-7";
export var dropdownButton = "_8r-e";
export var dropdownTitle = "_8r-9";
export var fullHeight = "_8r-5";
export var hidden = "_8r-a";
export var icon = "_8r-b";
export var mergeSuggestionWrapper = "_8r-m";
export var panel = "_8r-i";
export var portalButtonsWrapper = "_8r-c";
export var right = "_8r-j";
export var tableSummaryContainer = "_8r-8";
export var tableSummaryHeader = "_8r-g";
export var threeDotsButton = "_8r-f";
export var wide = "_8r-h";